import { Accordion, AccordionProps } from '@makyoapp/makyo-tw-ui'

export type CompAccordionProps = AccordionProps

export const CompAccordionCore = Accordion

// import { CSSProperties } from 'react'

// import { Accordion, ColorVariant } from '@makyoapp/makyo-tw-ui'

// import { IDBTable } from '@/core/db'
// import { ICell } from '@/core/models/columns'
// import { cleanUpText } from '@/shared/utils'

// export interface CompAccordionProps {
//   table: IDBTable
//   contentColId: string
//   accordionRows: {
//     title: ICell
//     content: ICell
//   }[]
//   multiple: boolean
//   wrapperStyles: Record<string, any> //contain margin, padding, etc
//   iconLeading: boolean
//   itemProps: Record<string, any>
//   contentTypoStyle: CSSProperties
//   textColor: string
//   dir: 'ltr' | 'rtl'
//   currentParentBg: ColorVariant
// }

// /**
//  * CompAccordionCore
//  */
// export const CompAccordionCore = ({
//   table,
//   contentColId,
//   multiple,
//   accordionRows,
//   wrapperStyles,
//   itemProps,
//   contentTypoStyle,
//   textColor,
//   dir,
//   currentParentBg,
// }: CompAccordionProps) => {
//   // generate items
//   const items = (accordionRows || []).map((row, i) => {
//     if (!row.title && !row.content) return null
//     // const itemCol = getColBrief(table, contentColId)
//     const item = cleanUpText(row.content && row.content.value ? row.content.value?.toString() : '')
//     return {
//       // content: (
//       //   <>
//       //     {itemCol?._Type === ColumnTypes.Rating || itemCol?._Type === ColumnTypes.Image ? (
//       //       <GetCellComponent
//       //         settings={itemCol?._Settings}
//       //         cell={row.content}
//       //         type={itemCol?._Type as ColumnTypes}
//       //         classNameImage='rounded-md'
//       //       />
//       //     ) : itemCol?._Type === ColumnTypes.RichText ? (
//       //       <ReactMDEditor.Markdown
//       //         components={{
//       //           p: (props) => (
//       //             <p
//       //               {...props}
//       //               style={{
//       //                 ...contentTypoStyle,
//       //               }}
//       //             />
//       //           ),
//       //         }}
//       //         style={{
//       //           backgroundColor: 'transparent',
//       //           boxSizing: 'border-box',
//       //           height: '100%',
//       //           margin: '0px',
//       //           color: 'inherit',
//       //           font: contentTypoStyle.font,
//       //           letterSpacing: contentTypoStyle.letterSpacing,
//       //           ...contentTypoStyle,
//       //         }}
//       //         source={item}
//       //       />
//       //     ) : (
//       //       item.toString()
//       //     )}
//       //   </>
//       // ).toString(),
//       content: (
//         <div></div>
//         // <CompRichTextCore
//         //   width={{ type: 'percentage', value: 100 }}
//         //   textColor={textColor}
//         //   componentAlign='center'
//         //   margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
//         //   align='center'
//         //   text={item.toString()}
//         //   backgroundColor={`var(--color-on-${currentParentBg})`}
//         //   foreGroundColor={`var(--color-${currentParentBg})`}
//         //   textOnForeground={`var(--color-on-${currentParentBg})`}
//         //   mdEditorStyle={{
//         //     '--md-sys-typescale-html-paragraph': contentTypoStyle.font,
//         //     '--md-sys-typescale-html-ul': contentTypoStyle.font,
//         //     '--md-sys-typescale-html-ol': contentTypoStyle.font,
//         //     '--md-sys-typescale-html-blockquote': contentTypoStyle.font,
//         //     '--md-sys-typescale-html-code': contentTypoStyle.font,
//         //     '--md-sys-typescale-html-pre': contentTypoStyle.font,
//         //     '--md-sys-typescale-html-a': contentTypoStyle.font,
//         //     ...contentTypoStyle,
//         //   }}
//         // />
//       ),
//       value: row.title?.toString(),
//       trigger: row.title?.toString(),
//     }
//   })

//   return <div>Accordion</div>

//   // return (
//   //   <Accordion
//   //     dir={dir}
//   //     titleTypography={wrapperStyles.typography.header?.typography}
//   //     contentTypography={wrapperStyles.typography.content?.typography}
//   //     openIcon={itemProps.openedIcon}
//   //     closedIcon={itemProps.closedIcon}
//   //     textColor={textColor}
//   //     align={wrapperStyles.justifyContent}
//   //     type={multiple ? 'multiple' : 'single'}
//   //     items={items.filter((item) => item !== null)}
//   //     wrapperSpacing={{
//   //       margin: {
//   //         top: 0,
//   //         bottom: 0,
//   //         left: 0,
//   //         right: 0,
//   //       },
//   //       padding: wrapperStyles.margin,
//   //     }}
//   //     backgroundColor={currentParentBg}
//   //     foregroundColor={`var(--color-${currentParentBg})`}
//   //     textOnForeground={`var(--color-on-${currentParentBg})`}
//   //     widthUnit={wrapperStyles.width.type}
//   //     widthAmount={wrapperStyles.width.value}
//   //     componentTitleSpacing={{
//   //       margin: wrapperStyles.titleMargin,
//   //       padding: {
//   //         top: 0,
//   //         bottom: 0,
//   //         left: 0,
//   //         right: 0,
//   //       },
//   //     }}
//   //   />
//   // )
// }
